import * as Redux from 'redux';
import {
  ProgramsState,
  ProgramsActionTypes,
  ProgramsEntity,
  Program,
  LevelsState,
  LevelsActionTypes,
  LevelsEntity,
  ProgramMemberState,
  ProgramMemberActionTypes,
  ProgramMemberEntity
} from './Types';
import {
  GET_PROGRAMS,
  REGISTER_PROGRAM,
  DELETE_PROGRAM,
  UPDATE_PROGRAM,
  GET_LEVELS,
  UPDATE_LEVELS,
  UPDATE_SCHEDULES,
  UPDATE_PROGRAM_MEMBERS,
  GET_PROGRAM_MEMBERS,
  initialDefaultProgramsState
} from './Constants';
import { CalendarActions } from '../calendar/calendar.event.types';
import { CALENDAR_EVENT_SELECTED, CREATE_CALENDAR_EVENT } from '../calendar/calendar.constants';
import { ReduxAction, SimpleResponse,  } from '../app/app.types';
import { isUndefined } from 'util';
import { REVERT_TO_INITIAL_STATE, REVERT_TO_INITIAL_STATE_EXCEPT_AUTH } from '../app/app.const';

export const programsReducer: Redux.Reducer<ProgramsState> = (
  programsState: ProgramsState = initialDefaultProgramsState, 
  action: ReduxAction<ProgramsActionTypes | CalendarActions, SimpleResponse<ProgramsEntity>>
): ProgramsState => {
  switch (action.type) {
    case `${GET_PROGRAMS}_FULFILLED`:
      return {...programsState,
        statusCode: action.payload.statusCode,
        programs: action.payload.body.list
      };
    case `${REGISTER_PROGRAM}_FULFILLED`:
      return {...programsState,
        statusCode: action.payload.statusCode,
        programs: programsState.programs.concat(action.payload.body.entity)
      };
    case `${DELETE_PROGRAM}_FULFILLED`:
      if (!isUndefined(action.meta)) {
        return {
          ...programsState,
          statusCode: action.payload.statusCode,
          programs: programsState.programs.filter((program: Program) => program.id !== action.meta!.id)
        };  
      } else {
        return programsState;
      }
    case `${UPDATE_PROGRAM}_FULFILLED`:
      if (!isUndefined(action.meta)) {
        return {
          ...programsState,
          statusCode: action.payload.statusCode,
          programs: programsState.programs
            .filter((program: Program) => program.id !== action.meta!.id)
            .concat(action.payload.body.entity)
        };  
      } else {
        return programsState;
      }
    case CALENDAR_EVENT_SELECTED:
      return {
        ...programsState,
        eventAction: 'EDIT',
        selectedEvent: {
          ...programsState.selectedEvent,
          id: action.payload.body.entity.id,
          title: action.payload.body.entity.title,
          backgroundColor: action.payload.body.entity.colorValue
        }
      };
    case CREATE_CALENDAR_EVENT:
      return {
        ...programsState,
        eventAction: 'CREATE',
        selectedEvent: {
          ...programsState.selectedEvent,
          id: action.payload.body.entity.id,
          title: action.payload.body.entity.title
        }
      };
    case `${UPDATE_LEVELS}_FULFILLED`: {
      const i: number = action.payload.body.programId ?
        programsState.programs
          .indexOf(programsState.programs.find((p: Program) => p.id === action.payload.body.programId)) :
        undefined;
      
      return {
        ...programsState,
        statusCode: action.payload.statusCode,
        programs: i !== undefined ?
         [
           ...programsState.programs.slice(0, i),
           {
             ...programsState.programs[i],
             levels: action.payload.body.levels ?
              action.payload.body.levels :
              programsState.programs[i].levels
           },
           ...programsState.programs.slice(i + 1)
         ] :
         programsState.programs
      };
    }
    case `${UPDATE_SCHEDULES}_FULFILLED`: {
      const i: number = action.payload.body.programId ?
        programsState.programs
          .indexOf(programsState.programs.find((p: Program) => p.id === action.payload.body.programId)) :
        undefined; 
      
      return {
        ...programsState,
        statusCode: action.payload.statusCode,
        programs: i !== undefined ?
         [
           ...programsState.programs.slice(0, i),
           {
             ...programsState.programs[i],
             schedules: action.payload.body.schedules ?
              action.payload.body.schedules :
              programsState.programs[i].schedules
           },
           ...programsState.programs.slice(i + 1)
         ] :
         programsState.programs
      };
    }
    case `${UPDATE_PROGRAM_MEMBERS}_FULFILLED`:
      return {
        ...programsState,
        statusCode: action.payload.statusCode
      };
    case REVERT_TO_INITIAL_STATE:
      return initialDefaultProgramsState;
    case REVERT_TO_INITIAL_STATE_EXCEPT_AUTH:
      return initialDefaultProgramsState;
    default:
      return programsState;
  }
};

const initialDefaultLevelsState = {
  statusCode: 0,
  levels: []
};

export const levelsReducer: Redux.Reducer<LevelsState> = (
  levelsState: LevelsState = initialDefaultLevelsState, 
  action: ReduxAction<LevelsActionTypes, SimpleResponse<LevelsEntity>>
): LevelsState => {
  switch (action.type) {
    case `${GET_LEVELS}_FULFILLED`:
      return {...levelsState,
        statusCode: action.payload.statusCode,
        levels: action.payload.body.levels
      };
    case REVERT_TO_INITIAL_STATE:
      return initialDefaultLevelsState;
    case REVERT_TO_INITIAL_STATE_EXCEPT_AUTH:
      return initialDefaultLevelsState;
    default:
      return levelsState;
  }  
};

const initialDefaultProgramMemberState = {
  statusCode: 0,
  programMembers: []
};

export const programMemberReducer: Redux.Reducer<ProgramMemberState> = (
  programMemberState: ProgramMemberState = initialDefaultProgramMemberState, 
  action: ReduxAction<ProgramMemberActionTypes, SimpleResponse<ProgramMemberEntity>>
): ProgramMemberState => {
  switch (action.type) {
    case `${GET_PROGRAM_MEMBERS}_FULFILLED`:
      return {...programMemberState,
        statusCode: action.payload.statusCode,
        programMembers: action.payload.body.list
      };
    case REVERT_TO_INITIAL_STATE:
      return initialDefaultProgramMemberState;
    case REVERT_TO_INITIAL_STATE_EXCEPT_AUTH:
      return initialDefaultProgramMemberState;
    default:
      return programMemberState;
  }  
};



// WEBPACK FOOTER //
// ./src/programs/Reducer.tsx